var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "justify-center", attrs: { id: "opdrachten" } },
    [
      _c("ehr-navigation", { attrs: { "active-item": "opdrachten" } }),
      _vm._v(" "),
      _c("div", { staticClass: "stack" }, [
        _c(
          "fieldset",
          [
            _c("legend", { staticClass: "visually-hidden" }, [_vm._v("Type")]),
            _vm._v(" "),
            _c(
              "RadioButton",
              {
                attrs: { id: "type-opdrachten", value: "opdrachten" },
                model: {
                  value: _vm.typeFilter,
                  callback: function($$v) {
                    _vm.typeFilter = $$v
                  },
                  expression: "typeFilter"
                }
              },
              [
                _c("EhrIcon", { attrs: { icon: "tasks" } }, [
                  _vm._v("Opdrachten")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "RadioButton",
              {
                attrs: { id: "type-onderbrekingen", value: "onderbrekingen" },
                model: {
                  value: _vm.typeFilter,
                  callback: function($$v) {
                    _vm.typeFilter = $$v
                  },
                  expression: "typeFilter"
                }
              },
              [
                _c("EhrIcon", { attrs: { icon: "pause" } }, [
                  _vm._v("Afwezigheden")
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "fieldset",
          [
            _c("legend", { staticClass: "visually-hidden" }, [
              _vm._v("Chronologie")
            ]),
            _vm._v(" "),
            _c(
              "RadioButton",
              {
                attrs: { id: "chronologie-alle", value: "Alle" },
                model: {
                  value: _vm.chronologieFilter,
                  callback: function($$v) {
                    _vm.chronologieFilter = $$v
                  },
                  expression: "chronologieFilter"
                }
              },
              [
                _c("EhrIcon", { attrs: { icon: "filter-circle-xmark" } }, [
                  _vm._v("Alle")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "RadioButton",
              {
                attrs: { id: "chronologie-verleden", value: "Verleden" },
                model: {
                  value: _vm.chronologieFilter,
                  callback: function($$v) {
                    _vm.chronologieFilter = $$v
                  },
                  expression: "chronologieFilter"
                }
              },
              [
                _c("EhrIcon", { attrs: { icon: "chevrons-left" } }, [
                  _vm._v("Verleden")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "RadioButton",
              {
                attrs: { id: "chronologie-heden", value: "Heden" },
                model: {
                  value: _vm.chronologieFilter,
                  callback: function($$v) {
                    _vm.chronologieFilter = $$v
                  },
                  expression: "chronologieFilter"
                }
              },
              [_c("EhrIcon", { attrs: { icon: "tasks" } }, [_vm._v("Heden")])],
              1
            ),
            _vm._v(" "),
            _vm.isChronologieFilterToekomstVisible
              ? _c(
                  "RadioButton",
                  {
                    attrs: { id: "chronologie-toekomst", value: "Toekomst" },
                    model: {
                      value: _vm.chronologieFilter,
                      callback: function($$v) {
                        _vm.chronologieFilter = $$v
                      },
                      expression: "chronologieFilter"
                    }
                  },
                  [
                    _c("EhrIcon", { attrs: { icon: "chevrons-right" } }, [
                      _vm._v("Toekomst")
                    ])
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container stack" },
          [
            _vm.typeFilter === "opdrachten" &&
            _vm.moduleSettings.volumeTewerkstelling
              ? _c("div", { staticClass: "uitleg-volume-tewerkstelling" }, [
                  _vm._v(_vm._s(_vm.moduleSettings.volumeTewerkstelling))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isLoading
              ? _c("is-loading", { staticClass: "content" })
              : _c(
                  "transition-group",
                  {
                    staticClass: "content",
                    attrs: { name: "list", tag: "div" }
                  },
                  [
                    _vm.typeFilter === "opdrachten"
                      ? _c("periodes-met-opdrachten", {
                          key: "opdrachten",
                          attrs: {
                            "periodes-met-opdrachten":
                              _vm.filteredPeriodesMetOpdrachten
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.typeFilter === "onderbrekingen"
                      ? _c("periodes-met-onderbrekingen", {
                          key: "onderbrekingen",
                          attrs: {
                            "periodes-met-onderbrekingen":
                              _vm.filteredPeriodesMetOnderbrekingen
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }